import { InstantAnswerBuilderFn } from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import {
  MessageRetailerOrBrandButton,
  additionalDataRequiredForContactingRetailerOrBrandCTA,
} from "../../shared/instantAnswerUtils";

import { getViewOrderInvoiceCTA } from "./shared";

export const ReplacementItemsIA: InstantAnswerBuilderFn = (strictLocalize) => {
  return {
    titleBuilder: (_context) => {
      return INVOICE_UPDATES(strictLocalize);
    },

    descriptionBuilder: (_context) => {
      return [INVOICE_UPDATES_EXPLANATION(strictLocalize)];
    },

    primaryCtaBuilder: {
      textBuilder: (context) => {
        return getViewOrderInvoiceCTA(context, strictLocalize)?.label;
      },
      linkBuilder: (context) => {
        return getViewOrderInvoiceCTA(context, strictLocalize)?.getLink?.(
          context.brandOrder
        );
      },
    },
    secondaryCtaBuilder: {
      textBuilder: (context) => {
        return MessageRetailerOrBrandButton(context, strictLocalize)?.label;
      },
      onClickFunctionBuilder: (context) => {
        return MessageRetailerOrBrandButton(context, strictLocalize)?.onClick;
      },
    },

    additionalRequiredData:
      additionalDataRequiredForContactingRetailerOrBrandCTA(),
  };
};

const INVOICE_UPDATES = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Invoice updates for replacement items",
    description: {
      text: "Title for the answer of how order invoices work for replacement items at Faire",
    },
  });

const INVOICE_UPDATES_EXPLANATION = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage:
      "When you choose to replace items, the reported items will be removed from your original invoice and a new order will be created for the brand to fulfil. You’ll then be charged for the replacement order once it ships on your new invoice due date. If you have any questions, please contact us.",
    description: {
      text: "Description for the answer of how order invoices work for replacement items at Faire",
    },
  });
